
import login from './modules/login'
import userList from './system/userList'
import menuList from './system/menuList'
import characterList from './system/characterList'
import tenant from './system/tenant'
import parkList from './park/parkList'
import house from './house/index'
import personList from './personList/index'
import thingYard from './thingYard/index'
import visitor from './visitor'
import activity from './activity'
import bnaner from './banner'
import workOrder from './workOrder'
import maintain from './maintain'
import payment from './payment'
import zlb from './zlb'
import nightPatrol from './nightPatrol'
import canteen from './canteen'
import home from './home'
import hgj from './hgj'
import integralShop from './integralShop'
import initiation from './initiation'

const Apis = Object.assign({},
  login,
  userList,
  menuList,
  characterList,
  tenant,
  parkList,
  house,
  personList,
  thingYard,
  visitor,
  activity,
  bnaner,
  workOrder,
  maintain,
  payment,
  zlb,
  nightPatrol,
  canteen,
  home,
  hgj,
  integralShop,
  initiation
)

export default Apis
